import React, { useState } from "react";
import { Routes, Route, Link, NavLink } from "react-router-dom";

import Home from "../screens/public/Home";
import Announcements from "../screens/public/Announcements";
import RoleSelection from "../screens/auth/RoleSelection";
import About from "../screens/public/About";
import Login from "../screens/auth/Login";
import logo from "../assets/logo.png";

import "./PublicLayout.css";

const PublicLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="public-layout">

      {/* ================= NAVBAR ================= */}
      <nav className="public-navbar">

        {/* Logo */}
        <Link to="/" className="public-logo-container" onClick={closeMenu}>
          <img
            src={logo}
            alt="Ghalib Library Logo"
            className="public-logo-image"
          />

          <div>
            <div className="public-logo">
              Ghalib Library
            </div>

            <div className="public-logo-sub">
              Library Management System
            </div>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <div className="desktop-links">

          <NavLink
            to="/"
            className={({ isActive }) =>
              `nav-link ${isActive ? "active-link" : ""}`
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/announcements"
            className={({ isActive }) =>
              `nav-link ${isActive ? "active-link" : ""}`
            }
          >
            Announcements
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              `nav-link ${isActive ? "active-link" : ""}`
            }
          >
            About
          </NavLink>

          <NavLink
            to="/login"
            className={({ isActive }) =>
              `login-btn ${isActive ? "active-login-btn" : ""}`
            }
          >
            Login / Signup
          </NavLink>

        </div>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          {menuOpen ? "✕" : "☰"}
        </button>

        {/* Mobile Navigation */}
        <div className={`mobile-menu ${menuOpen ? "mobile-menu-open" : ""}`}>

          <NavLink
            to="/"
            onClick={closeMenu}
            className={({ isActive }) =>
              `mobile-nav-link ${
                isActive ? "mobile-active-link" : ""
              }`
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/announcements"
            onClick={closeMenu}
            className={({ isActive }) =>
              `mobile-nav-link ${
                isActive ? "mobile-active-link" : ""
              }`
            }
          >
            Announcements
          </NavLink>

          <NavLink
            to="/about"
            onClick={closeMenu}
            className={({ isActive }) =>
              `mobile-nav-link ${
                isActive ? "mobile-active-link" : ""
              }`
            }
          >
            About
          </NavLink>

          <NavLink
            to="/login"
            onClick={closeMenu}
            className={({ isActive }) =>
              `mobile-login-btn ${
                isActive ? "mobile-active-login-btn" : ""
              }`
            }
          >
            Login / Signup
          </NavLink>

        </div>
      </nav>

      {/* ================= PAGE CONTENT ================= */}
      <main className="page-content">

        <Routes>

          <Route
            path="/"
            element={<Home />}
          />

          <Route
            path="/announcements"
            element={<Announcements />}
          />

          <Route
            path="/about"
            element={<About />}
          />

          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/roles"
            element={<RoleSelection />}
          />

        </Routes>

      </main>

      {/* ================= FOOTER ================= */}
      <footer className="public-footer">

        <div className="footer-container">

          {/* About */}
          <div className="footer-section">

            <h3>
              📚 Library Management System
            </h3>

            <p>
              Empowering learning through books,
              knowledge, and digital resources.
            </p>

          </div>

          {/* Quick Links */}
          <div className="footer-section">

            <h3>
              Quick Links
            </h3>

            <Link
              to="/"
              className="footer-link"
            >
              Home
            </Link>

            <Link
              to="/announcements"
              className="footer-link"
            >
              Announcements
            </Link>

            <Link
              to="/about"
              className="footer-link"
            >
              About Us
            </Link>

          </div>

          {/* Contact */}
          <div className="footer-section">

            <h3>
              Contact
            </h3>

            <p>
              📍{" "}
              <a
                href="https://maps.app.goo.gl/PQHPvX3exzVU9xiX6"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                Ghalib Library Location
              </a>
            </p>

            <p>
              📞 (021) 33517270
            </p>

            <p>
              📧 idaraeyyadgareghalib@gmail.com
            </p>

            <p>
              🕘 Mon - Fri | 3:00PM-7:30PM
            </p>
          </div>

        </div>

        <hr className="footer-line" />

        <p className="copyright">
          © {new Date().getFullYear()} Ghalib Library.
          All Rights Reserved.
        </p>

      </footer>

    </div>
  );
};

export default PublicLayout;